import React, { useState, useEffect } from 'react'
import axios from 'axios'
import {useTranslation} from "react-i18next";

const helptenLogo = require('./Helpten_logo_icon_white_lores.png')

const API_URL = process.env.NODE_ENV === 'production'
  ? '/api/login' : '/login'

export default () => {
  const [login, setLogin] = useState('')
  const [password, setPassword] = useState('')
  const [logins, setLogins] = useState(null)
  const [error, setError] = useState('')
  const {t} = useTranslation()

  useEffect(() => {
    if (logins && logins.length === 1) {
      window.location.href=logins[0].redirectUrl
    }
  })

  const getLogins = async event => {
    event.preventDefault()
    setError('')
    const logins = await axios.post(API_URL, {login, password})
    console.dir(logins.data.logins)
    if (!logins.data.logins.length) {
      setError(t('login.incorrectData'))
    }
    setLogins(logins.data.logins)
  }

  return (
    <div className="login-content">
      <img src={helptenLogo} height="50px"
        style={{marginTop: 20, display: 'block', marginLeft: 'auto', marginRight: 'auto'}}
        alt="Helpten logo"
      />
      <div className="title-tag" style={{paddingTop: 20}}>
        {t('login.authorization')}
      </div>

      { (logins == null || !logins.length) &&
        <div>
          {error &&
            <div role="alert" bsstyle="danger" className="alert show">
              { error }
            </div>
          }
          <form onSubmit={getLogins}>
            <input
              className="form-control"
              id="login-input"
              type="text"
              placeholder={t('common.login')}
              onChange={e => {
                e.preventDefault()
                setLogin(e.target.value)
              }}
            />
            <input
              className="form-control"
              id="password-input"
              type="password"
              placeholder={t('common.password')}
              onChange={e => {
                e.preventDefault()
                setPassword(e.target.value)
              }}
            />
            <button className="btn btn-lg btn-primary btn-block login-button" type="submit">{t('common.ok')}</button>
          </form>
        </div>
      }

      { (logins != null && logins.length === 1) &&
        <div>
          <p>{t('login.redirectToService')}</p>
        </div>
      }

      { (logins != null && logins.length > 1) &&
        <div>
        <p>{t('login.multipleServices')}</p>
          <ul className="services-list">
          {
            logins.map((l, i) =>
              <li key={i}>
                <a href={l.redirectUrl}>{l.server} {l.login}</a>
              </li>
            )
          }
          </ul>
          <button className="btn btn-primary" onClick={() => setLogins(null)}>{t('login.back')}</button>
        </div>
      }
    </div>
  )
}
